import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers';
import { clearSelection } from '../../../containers/Selection/actions';
import { SelectionClearerButton } from '../Toggler/styles';
import { Translate } from 'react-redux-i18n';

interface ClearSelectionProps {
	dispatch: Dispatch<StoreState>;
}

const SelectionClearer = (props: ClearSelectionProps) => {
	const { dispatch } = props;

	return (
		<SelectionClearerButton onClick={() => dispatch(clearSelection())}>
			<Translate value="messages.clear_selection" />
		</SelectionClearerButton>
	);
};


export default SelectionClearer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Selection/Clearer/index.tsx